import { APIClient } from '@/_helpers/APIClient'

export default {
  getRegisterInfo (payload) {
    let path = './api/get-register-info.json'
    return APIClient().get(path)
  }
}
